// src/pages/InsightsPage.js
import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from "react-helmet-async";
import './InsightsPage.css';

import { API_BASE } from '../config';



export default function InsightsPage() {
  const [insights, setInsights] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [category, setCategory] = useState('All');

  useEffect(() => {
    fetch(`${API_BASE}/api/insights/`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        setInsights(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load insights:', err);
        setError('Could not load insights.');
        setLoading(false);
      });
  }, []);

  const categories = useMemo(() => {
    const set = new Set(insights.map(i => i.category).filter(Boolean));
    return ['All', ...Array.from(set)];
  }, [insights]);

  const filtered = useMemo(() => {
    if (category === 'All') return insights;
    return insights.filter(i => i.category === category);
  }, [insights, category]);

  if (loading) {
    return (
      <main className="insights-page">
        <h1 className="insights-title">مقالات اختصاصی</h1>
        <p className="insights-status">Loading…</p>
      </main>
    );
  }

  if (error) {
    return (
      <main className="insights-page">
        <h1 className="insights-title">مقالات اختصاصی</h1>
        <p className="insights-error">{error}</p>
      </main>
    );
  }

  return (
    <main className="insights-page">
      <Helmet>
        <title>مقالات و تحلیل‌ها | زوپین مشاوره مدیریت</title>
        <meta name="description" content="مقالات تخصصی، تحلیل‌ها و ایده‌های تیم مشاوره زوپین در حوزه مدیریت و توسعه سازمانی" />
        <link rel="canonical" href="https://zoopin.co/insights" />
        <meta property="og:title" content="مقالات و تحلیل‌ها | زوپین مشاوره مدیریت" />
        <meta property="og:description" content="مقالات تخصصی، تحلیل‌ها و ایده‌های تیم مشاوره زوپین در حوزه مدیریت و توسعه سازمانی" />
        <meta property="og:url" content="https://zoopin.co/insights" />
        <meta name="twitter:title" content="مقالات و تحلیل‌ها | زوپین مشاوره مدیریت" />
        <meta name="twitter:description" content="مقالات تخصصی، تحلیل‌ها و ایده‌های تیم مشاوره زوپین در حوزه مدیریت و توسعه سازمانی" />
      </Helmet>
      <header className="insights-header">
      <h1 className="insights-title">مقالات اختصاصی</h1>
        <p className="insights-subtitle">تحلیل ها، ایده ها و تجربه های ما</p>
        <div className="insights-filters">
          {categories.map(cat => (
            <button
              key={cat}
              className={`filter-chip ${category === cat ? 'active' : ''}`}
              onClick={() => setCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </header>

      <section className="insights-grid">
        {filtered.map(item => {
          const imgSrc = item.image?.startsWith('http')
            ? item.image
            : `${API_BASE}${item.image || ''}`;
          // دانلود → PDF file
          const pdfHref = item.file?.startsWith('http')
            ? item.file
            : item.file ? `${API_BASE}${item.file}` : '';
          // مطالعه تحت وب → HTML link
          const webHref = item.link?.startsWith('http') ? item.link : '';
          // عنوان: اگر لینک وب هست به وب برو، وگرنه PDF
          const titleHref = webHref || pdfHref || '#';

        return (
          <article className="insight-card" key={item.id}>
            {imgSrc && <img className="insight-img" src={imgSrc} alt={item.title} />}
            <div className="insight-body">
              <div className="insight-meta">
                {item.category && <span className="insight-category">{item.category}</span>}
              </div>
              <a className="insight-title-link" href={titleHref} target="_blank" rel="noopener noreferrer">
                <h3 className="insight-title">{item.title}</h3>
              </a>
              <p className="insight-desc">{item.description}</p>
              <div className="insight-actions">
                {pdfHref && (
                  <a className="insight-link" href={pdfHref} target="_blank" rel="noopener noreferrer">
                    دانلود
                  </a>
                )}
                {webHref && (
                  <a className="insight-link insight-link-web" href={webHref} target="_blank" rel="noopener noreferrer">
                    مطالعه تحت وب
                  </a>
                )}
              </div>
            </div>
          </article>
        )})}
      </section>

      {filtered.length === 0 && (
        <p className="insights-empty">No insights in this category yet.</p>
      )}
    </main>
  );
}
